import { createContext, useContext, useState, useCallback } from "react";
import ToastContainer from "../components/ui/ToastContainer";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
 const [toasts, setToasts] = useState([]);
 const [history, setHistory] = useState([]);

 const showToast = useCallback((message, type = "info") => {
 const id = Date.now() + Math.random();
 const newToast = { id, message, type, date: new Date() };
 
 setToasts((prev) => [...prev, newToast]);
 setHistory((prev) => [newToast, ...prev].slice(0, 50)); // Keep last 50
 
 // Auto remove after 5 seconds
 setTimeout(() => {
 setToasts((prev) => prev.filter((t) => t.id !== id));
 }, 5000);
 }, []);

 const removeToast = useCallback((id) => {
 setToasts((prev) => prev.filter((t) => t.id !== id));
 }, []);

 const clearHistory = useCallback(() => {
 setHistory([]);
 }, []);

 return (
 <NotificationContext.Provider value={{ showToast, removeToast, history, clearHistory }}>
 {children}
 <ToastContainer toasts={toasts} removeToast={removeToast} />
 </NotificationContext.Provider>
 );
};
